export const RIBBON_MESSAGE = process.env.RIBBON_MESSAGE;

export const RIBBON_LINK = process.env.RIBBON_LINK;

export const RIBBON_COLOR = process.env.RIBBON_COLOR;

export const RIBBON_BACKGROUND_COLOR = process.env.RIBBON_BACKGROUND_COLOR;
